(function () {
  'use strict';

  angular.module('ringbaPortal').directive('clickAndDisable', clickAndDisable);

  function clickAndDisable(
    $compile,
    bsLoadingOverlayService
  ) {
    const directive = {
      restrict: 'A',
      scope: {
        asyncAction: '&clickAndDisable',
        loaderRefId: '@'
      },
      compile: compile
    };
    return directive;

    function compile(element) {
      let loaderElementHTML;
      const loaderRefId = angular.element(element).attr('loader-ref-id');
      if (loaderRefId) {
        loaderElementHTML = '<span bs-loading-overlay bs-loading-overlay-reference-id="' + loaderRefId + '" class="loader-container size-sm"></span>';
      } else {
        loaderElementHTML = '<span bs-loading-overlay class="loader-container size-sm"></span>';
      }
      const loaderElement = angular.element(loaderElementHTML);
      element.addClass('btn-loader');
      element.append(loaderElement);
      $compile(loaderElement);
      return link;
    }

    function link(scope, element) {
      element.bind('click', function () {
        if (scope.loaderRefId) {
          bsLoadingOverlayService.start({
            referenceId: scope.loaderRefId
          });
        } else {
          bsLoadingOverlayService.start();
        }

        element.prop('disabled', true);

        scope.$apply(function () {
          if (scope.asyncAction) {
            const promise = scope.asyncAction();
            if (promise) {
              promise.finally(_endLoading);
            } else {
              _endLoading();  
            }
          } else {
            _endLoading();
          }
        });
      });

      function _endLoading() {
        if (scope.loaderRefId) {
          bsLoadingOverlayService.stop({
            referenceId: scope.loaderRefId
          });
        } else {
          bsLoadingOverlayService.stop();
        }
        element.prop('disabled', false);
      }
    }
  }
})();
